import { AppPaths } from 'src/app/app-paths.constants';

export class MenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [
        {
          title: 'Home page',
          root: true,
          alignment: 'left',
          page: AppPaths.Home.Root.StringPath,
          translate: AppPaths.Home.Root.PageData.Title,
        },
        {
          title: 'Contact',
          root: true,
          alignment: 'left',
          page: AppPaths.Home.Contact.StringPath,
          translate: AppPaths.Home.Contact.PageData.Title
        },
        {
          title: 'Rules',
          root: true,
          alignment: 'left',
          translate: 'HOME.RULES-MENU-TITLE',
          submenu: [
            {
              title: 'Rules - Warsaw',
              alignment: 'left',
              page: AppPaths.Home.RulesWarsaw.StringPath,
              translate: AppPaths.Home.RulesWarsaw.PageData.Title
            },
            {
              title: 'Rules - Gdansk',
              alignment: 'left',
              page: AppPaths.Home.RulesGdansk.StringPath,
              translate: AppPaths.Home.RulesGdansk.PageData.Title
            },
            {
              title: 'Rules - Bytom',
              alignment: 'left',
              page: AppPaths.Home.RulesBytom.StringPath,
              translate: AppPaths.Home.RulesBytom.PageData.Title
            }
          ]
        },
        {
          title: 'Dashboard Home',
          root: true,
          alignment: 'left',
          page: AppPaths.App.Dashboard.Home.StringPath,
          translate: AppPaths.App.Dashboard.Home.PageData.Other.MenuItemTitle
        }
      ]
    },
    aside: {
      self: {},
      items: [
        {
          title: 'Home page',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.Home.Root.StringPath,
          translate: AppPaths.Home.Root.PageData.Title,
          bullet: 'dot',
        },
        {
          title: 'Contact',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.Home.Contact.StringPath,
          translate: AppPaths.Home.Contact.PageData.Title,
          bullet: 'dot',
        },
        {
          title: 'Rules - Warsaw',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.Home.RulesWarsaw.StringPath,
          translate: AppPaths.Home.RulesWarsaw.PageData.Title,
          bullet: 'dot',
        },
        {
          title: 'Rules - Gdansk',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.Home.RulesGdansk.StringPath,
          translate: AppPaths.Home.RulesGdansk.PageData.Title,
          bullet: 'dot',
        },
        {
          title: 'Rules - Bytom',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.Home.RulesBytom.StringPath,
          translate: AppPaths.Home.RulesBytom.PageData.Title,
          bullet: 'dot',
        },
        {
          title: 'Dashboard Home',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: AppPaths.App.Dashboard.Home.StringPath,
          translate: AppPaths.App.Dashboard.Home.PageData.Title,
          bullet: 'dot'
        }
      ]
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
